var _defs, _use, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamingAppTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "79px",
    viewBox: "0 0 88 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "9.70428719%",
    x2: "0%",
    y2: "90.2957128%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3372B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E0F0A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81,5 C85.418278,5 89,8.581722 89,13 L89,76 C89,80.418278 85.418278,84 81,84 L9,84 C4.581722,84 1,80.418278 1,76 L1,13 C1,8.581722 4.581722,5 9,5 L81,5 Z M82,69 L75,69 L75,76 L82,76 L82,69 Z M15,69 L8,69 L8,76 L15,76 L15,69 Z M82,55 L75,55 L75,62 L82,62 L82,55 Z M15,55 L8,55 L8,62 L15,62 L15,55 Z M82,41 L75,41 L75,48 L82,48 L82,41 Z M15,41 L8,41 L8,48 L15,48 L15,41 Z M82,27 L75,27 L75,34 L82,34 L82,27 Z M15,27 L8,27 L8,34 L15,34 L15,27 Z M82,13 L75,13 L75,20 L82,20 L82,13 Z M15,13 L8,13 L8,20 L15,20 L15,13 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.1393581%",
    y1: "0.506722674%",
    x2: "90.464527%",
    y2: "90.2957128%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2718",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9251C",
    stopOpacity: 0.36909965,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.9732208%",
    y1: "91.566132%",
    x2: "25.2064732%",
    y2: "19.6777344%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.867132867,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1row_4pos",
    transform: "translate(-1.000000, -72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.396006337,
    fill: "#FF0000",
    style: {
      mixBlendMode: "soft-light"
    },
    xlinkHref: "#path-2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Fill-Outline",
    stroke: "url(#linearGradient-3)",
    strokeWidth: 2,
    opacity: 0.490164621,
    x: 2,
    y: 6,
    width: 86,
    height: 77,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9991998,28.6180338 L62.7631318,44.9999998 L29.9991998,61.3819659 L29.9991998,28.6180338 Z",
    id: "Play",
    strokeOpacity: 0.332167832,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamingAppTile);
export default __webpack_public_path__ + "static/media/streaming_app_tile.a9e650dd4cdc2bd6e8a85fcac5139847.svg";
export { ForwardRef as ReactComponent };